module.exports = __webpack_public_path__ + "img/Slider_Design.2193afa5.jpg";